/* eslint-disable max-len */
import 'react';

const HelperBtnSvg = () => {
    return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_5012_10412)">
                <path d="M0 18C0 8.05887 8.05887 0 18 0C27.9411 0 36 8.05887 36 18C36 27.9411 27.9411 36 18 36C8.05887 36 0 27.9411 0 18Z" fill="white" />
                <mask id="mask0_5012_10412" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x="6" y="6" width="24" height="24">
                    <rect x="30" y="6" width="24" height="24" transform="rotate(90 30 6)" fill="#FF0606" />
                </mask>
                <g mask="url(#mask0_5012_10412)">
                    <path d="M13.8 15.4417C13.8 13.1221 15.6804 11.7667 18 11.7667C20.3196 11.7667 22.2 13.1221 22.2 15.4417C22.2 17.0747 20.6387 18.2299 19.3481 18.7706C18.6349 19.0694 18 19.7435 18 20.5167V20.7792" stroke="#77787A" strokeWidth="1.7" strokeLinecap="round" />
                    <circle cx="18.0001" cy="24.5416" r="1.4784" fill="#77787A" />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_5012_10412">
                    <rect width="36" height="36" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};


export default HelperBtnSvg;
